import React, { useState, useEffect } from "react"
import Navbar from "./navbar"
import SideBarComponent from "./sidebar/index"
import Spinner from "react-bootstrap/esm/Spinner"
import { Switch } from "react-router-dom"
import { PrivateRoutes, AggregatorRoutes } from "../routes"
import { Redirect, Route } from "react-router-dom"
import useAuth from "../context/userContext"
import Notification from "./notification"
import api from "../utils/api"
import { SuccessNotification } from "../utils"
import PermissionDebug from "../components/PermissionDebug"
import UserDataTest from "../components/UserDataTest"
import ActivityRoleFetcher from "../components/ActivityRoleFetcher"
import ImpersonationBanner from "../components/ImpersonationBanner"
import { canAccessPath } from "../utils/accessControl"

const DashboardLayout = () => {
  const [selectedItem, setselectedItem] = useState("Dashboard")
  const [showNotification, setShowNotification] = useState(false)
  const [showSidebar, setSidebar] = useState(true)
  const [messages, setMessages] = useState()
  const [unreadmessages, unsetReadMessages] = useState()

  const obj = JSON.parse(localStorage.getItem("user"))
  const userType = obj.user_type
  const { permissions, user } = useAuth()
  const userData = user || obj || {}

  const getallNotifications = async () => {
    let token = localStorage.getItem("token")
    var allmessages = []
    try {
      api.defaults.headers.Authorization = `Bearer ${token}`
      const response = await api.get("notification/getallNotifications/")
      let m = response.data.notifications
      for (var i = 0; i < m.length; i++) {
        if (m[i].read == false) {
          allmessages.push(m[i])
        }
        unsetReadMessages(allmessages)
      }
      setMessages(response.data.notifications)
    } catch (error) {

    }
  }

  const deleteallNotifications = async () => {
    let token = localStorage.getItem("token")
    try {
      api.defaults.headers.Authorization = `Bearer ${token}`
      const response = await api.delete("deleteallNotifications/")
      SuccessNotification("You have deleted all notifications successfully")
    } catch (error) {

    }
  }

  const deleteSingleNotification = async (id) => {
    let token = localStorage.getItem("token")
    try {
      api.defaults.headers.Authorization = `Bearer ${token}`
      const response = await api.get(`deleteSingleNotification/${id}/`)
      setMessages(response.data.remaining_notifications)
      SuccessNotification("You have deleted this notification successfully")
    } catch (error) {

    }
  }

  const updateNotification = async (id) => {
    let token = localStorage.getItem("token")
    var data = JSON.stringify({
      read: true,
    })
    try {
      api.defaults.headers.Authorization = `Bearer ${token}`
      const response = await api.post(`updatenotification/${id}/`)
      // getallNotifications()
    } catch (error) {

    }
  }

  // useEffect(() => {
  //   getallNotifications()
  // }, [])

  const setLink = (item) => {
    setselectedItem(item)
  }

  const isImpersonation = window.localStorage.getItem("is_impersonation") === "true"
  const bannerHeight = isImpersonation ? "pt-28" : "pt-14"

  return (
    <>
      <ImpersonationBanner />
      <div className="flex h-screen bg-[#F6F6F7] dark:bg-secondaryDark overflow-hidden relative">
        <SideBarComponent
          setSidebar={setSidebar}
          selectedItem={selectedItem}
          setLink={setLink}
        />
        <div className={`flex transition-all duration-300 flex-col h-screen flex-1 overflow-x-auto mb-[10px] ${bannerHeight}`}>
          {isImpersonation ? null : <Navbar
            showNotification={showNotification}
            setShowNotification={setShowNotification}
            messages={messages}
            unreadmessages={unreadmessages}
            showSidebar={showSidebar}
            setSidebar={setSidebar}
          />}
          <React.Suspense fallback={<Spinner />}>
            <Switch>
              {/* {userType === "Service Provider"} */}
              {userType === "miller" || userType === "processor"
                ? PrivateRoutes.filter((prop) => canAccessPath(prop.layout + prop.path, permissions, userData)).map((prop, key) => {
                  return (
                    <Route
                      path={prop.layout + prop.path}
                      component={prop.component}
                      exact={prop.exact}
                      key={key}
                    />
                  )
                })
                : AggregatorRoutes.filter((prop) => canAccessPath(prop.layout + prop.path, permissions, userData)).map((prop, key) => {
                  return (
                    <Route
                      path={prop.layout + prop.path}
                      component={prop.component}
                      exact={prop.exact}
                      key={key}
                    />
                  )
                })}
              {/* {PrivateRoutes.map((prop, key) => {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  exact={prop.exact}
                  key={key}
                />
              )
            })} */}
            </Switch>
          </React.Suspense>
        </div>
        <Notification
          setShowNotification={setShowNotification}
          showNotification={showNotification}
          messages={messages}
          deleteallNotifications={deleteallNotifications}
          deleteSingleNotification={deleteSingleNotification}
          updateNotification={updateNotification}
        />

        {/* Debug components - remove in production */}
        {/* <PermissionDebug /> */}
        {/* <UserDataTest /> */}
        <ActivityRoleFetcher />
      </div>
    </>
  )
}

export default DashboardLayout
